/**
 * @generated SignedSource<<4315d64fe74c5ad99e833a916deafe92>>
 * @relayHash fbef4efdf70b6e718c12954d945421ea
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID fbef4efdf70b6e718c12954d945421ea

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "code"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "codeId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      },
      {
        "kind": "Variable",
        "name": "codeId",
        "variableName": "codeId"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "checkOtpCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckOtpCodeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CheckOtpCodeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "fbef4efdf70b6e718c12954d945421ea",
    "metadata": {},
    "name": "CheckOtpCodeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "b2b4f2b358ffd4d025397917a7baa332";

export default node;
